import React, { useState, useEffect } from 'react'
import {
	PAYMENT_TYPES_SELECT_ITEMS,
	SCI_SELECT_ITEMS,
	ACCOUNTING_IDENTIFIER_SELECT_ITEMS,
} from '../../../constants'
import { Dropdown } from '../../../common/DropDown'
import {
	validateAlphaIfPresent,
	validateAlphaNumericIfPresent,
	hasError,
	removeError,
	validateNumericIfPresent,
	validateFieldLengthIfPresent,
	handleHsCode,
	validateDecimalIfPresent,
	validateSuppleCusInfoIfPresent,
} from '../captureAwbUtils'
import plusIcon from '../../../assets/images/plusBlue.svg'
// import deleteIcon from '../../../assets/images/delete.svg'
import { useTranslation } from 'react-i18next'
import { CommonDropDown } from '../../../common/Resusable/CommonDropDown'
import CommonInput from '../../../common/Resusable/CommonInput'
import deleteIcon from "../../../assets/images/delete_icon_red.png";
const CustomsDetails = ({ awbDetails, setAwbDetails, bookingDetails,validationRule, error, setError, awbRoutingData, isDisabled}) => {
	//for multilingual
	const { t, i18n } = useTranslation(['labels', 'errors'])
	const [isHsCodeRequired, setIsHsCodeRequired] = useState(false);

	let {
		awbChargeDeclaration,
		accountingInformationDetails,
		customsInformationDetails,
		currency,
	} = awbDetails

	useEffect(() => {}, [])

	const handleAddCustomsInfo = () => {
		const customsInfo = {
			informationIdentifier: '',
			customsInformationIdentifier: '',
			supplementaryCustomsControlInformation: '',
			countryCode: '',
			isNew: true,
		}
		customsInformationDetails?.push(customsInfo)
		setAwbDetails((prevState) => ({
			...prevState,
			customsInformationDetails: customsInformationDetails,
		}))
	}

	useEffect(() => {
		if (bookingDetails|| awbDetails) {
			checkHsCodeRequirement();
		}
	}, [bookingDetails, awbRoutingData]);

	const checkHsCodeRequirement = () => {
		if (validationRule && validationRule?.length > 0) {
			const isDestinationInBookingDetails = bookingDetails?.bookingDetails?.bookingFlightDetails?.some(
				(flightDetail) =>
					validationRule?.some(
						(rule) => rule?.airports?.includes(flightDetail?.segmentDestination)
					)
			);

			const isDestinationInAwbDetails = awbDetails?.awbRouting?.some(
				(routingDetail) =>
					validationRule?.some(
						(rule) => rule?.airports?.includes(routingDetail?.airport)
					)
			);

			const isHsCodeRequired = isDestinationInBookingDetails || isDestinationInAwbDetails;
			setIsHsCodeRequired(isHsCodeRequired);
		}

	};


	const handleDeleteAction = (e, index) => {
		const customsInformationDetailsTemp = customsInformationDetails?.filter(
			(itemDetail, curr) => {
				return index !== curr
			}
		)
		setAwbDetails((prevState) => ({
			...prevState,
			customsInformationDetails: customsInformationDetailsTemp,
		}))
	}

	const handleAddAccountingInfo = () => {
		const accountingInfo = {
			accountingInformationIdentifier: '',
			accountingInformation: '',
			isNew: true,
		}
		accountingInformationDetails?.push(accountingInfo)
		setAwbDetails((prevState) => ({
			...prevState,
			accountingInformationDetails: accountingInformationDetails,
		}))
	}

	const handleAccountingDeleteAction = (e, index) => {
		const accountingInformation = accountingInformationDetails?.filter(
			(itemDetail, curr) => {
				return index !== curr
			}
		)
		setAwbDetails((prevState) => ({
			...prevState,
			accountingInformationDetails: accountingInformation,
		}))
	}

	var trimDecimalValue = function( val, decimals ) {
		if ( parseFloat( val ) ) {
			var numeric_string = String(val);
			var parts = numeric_string?.split( '.', 2);
			if ( parts[1] && parts[1].length > decimals ) {
				let slicedString = parts[0]+'.'+parts[1].slice(0,3)
				return slicedString?.slice(0,13)
			}
			else {
				if(val % 1 !== 0){
					let numberString = String(val)
					return numberString?.slice(0,13)
				}
				else{
					let numberString = String(val)
					return numberString?.slice(0,12)
				}
			}
		}
	}

	return (
		<div className='portal-row cutom-details'>
			<div className='portal-col'>
				<div className='customs-details-wrapper'>
					<div className='customs-details-section form-row'>
						<div className='shipping-deparr-row'>
							<CommonDropDown
								// label={t("COMMON.UNIT_TYPE")}
								id='sci'
								value={awbDetails.sci}
								options={SCI_SELECT_ITEMS}
								label='SCI'
								onChange={(e) => {
									setAwbDetails((prevState) => ({
										...prevState,
										sci: e.target.value,
									}))
									//validateRequired(e.target.value, setError, 'sci')
								}}
								ariaInvalid={hasError('sci', error)}
								onFocus={(e) => {
									removeError(e, setError)
								}}
								disabled={isDisabled}
							/>

							{/* <Dropdown
										id='sci'
										value={awbDetails.sci}
										options={SCI_SELECT_ITEMS}
										label='SCI'
										onChange={(e) => {
											setAwbDetails((prevState) => ({
												...prevState,
												sci: e.target.value,
											}))
											//validateRequired(e.target.value, setError, 'sci')
										}}
										ariaInvalid={hasError('sci', error)}
										onFocus={(e) => {
											removeError(e, setError)
										}}
									></Dropdown> */}
							{/* <span className='form-item__error'>
										{error && error['sci'] ? error['sci'] : ''}
									</span> */}


							<CommonDropDown
								id='customsPaymentType'
								disabled={isDisabled}
								value={
									awbChargeDeclaration.prepaidCollectChargeDeclaration
										.prepaidCollectIndicatorWgtValChgs
								}
								options={PAYMENT_TYPES_SELECT_ITEMS}
								label={t('CAPTURE_AWB.PAY_TYPE')}
								onChange={(e) => {
									awbChargeDeclaration.prepaidCollectChargeDeclaration.prepaidCollectIndicatorWgtValChgs =
										e.target.value
									setAwbDetails((prevState) => ({
										...prevState,
										awbChargeDeclaration: awbChargeDeclaration,
									}))
									/*validateRequired(
										e.target.value,
										setError,
										'customsPaymentType'
									)*/
								}}
								ariaInvalid={hasError('customsPaymentType', error)}
								onFocus={(e) => {
									removeError(e, setError)
								}}
							/>

							{/* <Dropdown
											id='customsPaymentType'
											value={
												awbChargeDeclaration.prepaidCollectChargeDeclaration
													.prepaidCollectIndicatorWgtValChgs
											}
											options={PAYMENT_TYPES_SELECT_ITEMS}
											label={t('CAPTURE_AWB.PAY_TYPE')}
											onChange={(e) => {
												awbChargeDeclaration.prepaidCollectChargeDeclaration.prepaidCollectIndicatorWgtValChgs =
													e.target.value
												setAwbDetails((prevState) => ({
													...prevState,
													awbChargeDeclaration: awbChargeDeclaration,
												}))
												
											}}
											ariaInvalid={hasError('customsPaymentType', error)}
											onFocus={(e) => {
												removeError(e, setError)
											}}
										/> */}
							{/* <span className='form-item__error'>
											{error && error['customsPaymentType']
												? error['customsPaymentType']
												: ''}
										</span> */}

						</div>
						<div className='shipping-deparr-row'>

							<div
								className={`form-group ${hasError('dvCustoms', error) ? "red-border" : ""
									}`}
							>
								<CommonInput
									id='dvCustoms'
									type='number'
									disabled={isDisabled}
									maxLength={awbChargeDeclaration.declaredValueForCustoms % 1 === 0 ? '12' : '13'}
									label={`${t('CAPTURE_AWB.DV_CSTM')}(${currency})`}
									value={awbChargeDeclaration.declaredValueForCustoms}
									onChange={(e) => {
										let trimmedValue = trimDecimalValue(e.target.value, 2)
										awbChargeDeclaration.declaredValueForCustoms = trimmedValue
										setAwbDetails((prevState) => ({
											...prevState,
											awbChargeDeclaration: awbChargeDeclaration,
										}))
									}}
									onBlur={(e) => {
										validateDecimalIfPresent(
											e.target.value,
											setError,
											'dvCustoms'
										)
									}}
									aria-invalid={hasError('dvCustoms', error)}
									onFocus={(e) => {
										removeError(e, setError)
									}}
									error={error && error['dvCustoms']
										? t(error['dvCustoms'], { ns: 'errors' })
										: ''}
								/>
							</div>

							<div
								className={`form-group ${hasError('dvCarriage', error) ? "red-border" : ""
									}`}
							>
								<CommonInput
									id='dvCarriage'
									type='number'
									disabled={isDisabled}
									label={`${t('CAPTURE_AWB.DV_CARRIAGE')}(${currency})`}
									maxLength={awbChargeDeclaration.declaredValueForCarriage % 1 === 0 ? '12' : '13'}
									value={awbChargeDeclaration.declaredValueForCarriage}
									onChange={(e) => {
										let trimmedValue = trimDecimalValue(e.target.value, 2)
										awbChargeDeclaration.declaredValueForCarriage = trimmedValue
										setAwbDetails((prevState) => ({
											...prevState,
											awbChargeDeclaration: awbChargeDeclaration,
										}))
									}}
									onBlur={(e) => {
										validateDecimalIfPresent(
											e.target.value,
											setError,
											'dvCarriage'
										)
									}}
									aria-invalid={hasError('dvCarriage', error)}
									onFocus={(e) => {
										removeError(e, setError)
									}}
									error={error && error['dvCarriage']
										? t(error['dvCarriage'], { ns: 'errors' })
										: ''}
								/>
							</div>

							{/* <div
									className='col-6 col-lg-2 form-item form-item--text'
									data-module='molecules/form-item/FormItem'
								>
									<label className='form-item__label'>{`${t(
										'COMMON.DV_CARRIAGE'
									)}(${currency})`}</label>
									<input
										id='dvCarriage'
										type='number'
										className='form-item__field'
										maxLength={awbChargeDeclaration.declaredValueForCarriage % 1 === 0 ? '12' : '13'}
										placeholder='DV carriage'
										value={awbChargeDeclaration.declaredValueForCarriage}
										onChange={(e) => {
											let trimmedValue = trimDecimalValue(e.target.value, 2)
											awbChargeDeclaration.declaredValueForCarriage = trimmedValue
											setAwbDetails((prevState) => ({
												...prevState,
												awbChargeDeclaration: awbChargeDeclaration,
											}))
										}}
										onBlur={(e) => {
											validateDecimalIfPresent(
												e.target.value,
												setError,
												'dvCarriage'
											)
										}}
										aria-invalid={hasError('dvCarriage', error)}
										onFocus={(e) => {
											removeError(e, setError)
										}}
									/>
									<span className='form-item__error'>
										{error && error['dvCarriage']
											? t(error['dvCarriage'], { ns: 'errors' })
											: ''}
									</span>
								  </div> */}

						</div>
						<div className='shipping-deparr-row'>

							<div
								className={`form-group ${hasError('hsCode', error) ? "red-border" : ""
									}`}
							>
								<CommonInput
									id='hsCode'
									type='text'
									disabled={isDisabled}
									label={isHsCodeRequired ? t('CAPTURE_AWB.HS_CODE_MANDATORY') : t('CAPTURE_AWB.HS_CODE')}
									maxLength='100'
									value={awbDetails.hccs ? awbDetails.hccs.toUpperCase() : ''}
									onChange={(e) => {
										setAwbDetails((prevState) => ({
											...prevState,
											hccs: e.target.value
												? e.target.value.split(' ').join('')
												: '',
										}))
									}}
									onBlur={(e) => {
										handleHsCode(e.target.value, setError, isHsCodeRequired)
									}}
									aria-invalid={hasError('hsCode', error)}
									onFocus={(e) => {
										removeError(e, setError)
									}}
									error={error && error['hsCode']
										? t(error['hsCode'], { ns: 'errors' })
										: ''}
								/>
							</div>

							{/* <div
									className='col-6 col-lg-2 mt-md-2 mt-lg-0 form-item form-item--text'
									data-module='molecules/form-item/FormItem'
								>
									<label className='form-item__label'>
										{isHsCodeRequired ? t('CAPTURE_AWB.HS_CODE_MANDATORY') : t('CAPTURE_AWB.HS_CODE')}
									</label>
									<input
										id='hsCode'
										type='text'
										className='form-item__field'
										maxLength='100'
										value={awbDetails.hccs ? awbDetails.hccs.toUpperCase() : ''}
										onChange={(e) => {
											setAwbDetails((prevState) => ({
												...prevState,
												hccs: e.target.value
													? e.target.value.split(' ').join('')
													: '',
											}))
										}}
										onBlur={(e) => {
											handleHsCode(e.target.value, setError, isHsCodeRequired)
										}}
										aria-invalid={hasError('hsCode', error)}
										onFocus={(e) => {
											removeError(e, setError)
										}}
									/>
									<span className='form-item__error'>
										{error && error['hsCode']
											? t(error['hsCode'], { ns: 'errors' })
											: ''}
									</span>
								</div> */}

							<div
								className={`form-group ${hasError('handlingInfo', error) ? "red-border" : ""
									}`}
							>
								<CommonInput
									id='handlingInfo'
									type='text'
									disabled={isDisabled}
									label={t('CAPTURE_AWB.HANDLING_INFO')}
									maxLength='140'
									value={awbDetails.handlingInfo ? awbDetails.handlingInfo.toUpperCase() : ''}
									onChange={(e) => {
										setAwbDetails((prevState) => ({
											...prevState,
											handlingInfo: e.target.value,
										}))
									}}
									onBlur={(e) => {
										validateAlphaNumericIfPresent(
											e.target.value,
											setError,
											'handlingInfo'
										)
									}}
									aria-invalid={hasError('handlingInfo', error)}
									onFocus={(e) => {
										removeError(e, setError)
									}}
									error={error && error['handlingInfo']
										? t(error['handlingInfo'], { ns: 'errors' })
										: ''}
								/>
							</div>

						</div>

					</div>	
					<div className='portal-row'>
						<div className='portal-col accounting-info-wrapper'>
							<div className='portal-row'>
								<div className='portal-col'>
									<label className='section-sub-heading mb-0'>
										{t('CAPTURE_AWB.ACCOUNTING_INFO')}
									</label>
								</div>
							</div>
							{accountingInformationDetails &&
							accountingInformationDetails.length ? (
								accountingInformationDetails.map((info, index) => (
									<div className='accounting-info-section form-row'>
										<div className='shipping-deparr-row'>
											<CommonDropDown
												id={`accountInfoId${index}`}
												disabled={isDisabled}
												value={info.accountingInformationIdentifier}
												options={ACCOUNTING_IDENTIFIER_SELECT_ITEMS}
												label={t('CAPTURE_AWB.IDENTIFIER')}
												onChange={(e) => {
													accountingInformationDetails[
														index
													].accountingInformationIdentifier = e.target.value
													setAwbDetails((prevState) => ({
														...prevState,
														accountingInformationDetails:
															accountingInformationDetails,
													}))
													/*validateRequired(
												e.target.value,
												setError,
												'accountInfoId'
											)*/
												}}
												ariaInvalid={hasError(`accountInfoId${index}`, error)}
												onFocus={(e) => {
													removeError(e, setError)
												}}
											/>


											<div
												className={`form-group ${hasError('accountingInformation', error) ? "red-border" : ""
													}`}
											>
												<CommonInput
													id={`accountingInformation${index}`}
													type='text'
													disabled={isDisabled}
													label={t('CAPTURE_AWB.INFO')}
													maxLength='34'
													value={info.accountingInformation ? info.accountingInformation.toUpperCase() : ''}
													onChange={(e) => {
														accountingInformationDetails[
															index
														].accountingInformation = e.target.value
														setAwbDetails((prevState) => ({
															...prevState,
															accountingInformationDetails:
																accountingInformationDetails,
														}))
													}}
													onBlur={(e) => {
														validateAlphaNumericIfPresent(
															e.target.value,
															setError,
															`accountingInformation${index}`
														)
													}}
													aria-invalid={hasError(
														`accountingInformation${index}`,
														error
													)}
													onFocus={(e) => {
														removeError(e, setError)
													}}
													error={error && error[`accountingInformation${index}`]
														? t(error[`accountingInformation${index}`], {
															ns: 'errors',
														})
														: ''}
												/>
											</div>


                                             {accountingInformationDetails.length > 1 && (
												<div className='delete-section ml-auto mt-auto' onClick={(e) => handleAccountingDeleteAction(e, index)}>
													<img src={deleteIcon} alt="Trash" title="Trash" id='Trash-icon' />
													<span>{t("CAPTURE_AWB.REMOVE")}</span>
												</div>
										)}
										</div>	
										{/* {info.isNew && (
											<div className='col-12 col-md-1'>
												<button className='delete-button'>
													<i className='icon'>
														<img
															src={deleteIcon}
															alt='Delete'
															title='Delete'
															onClick={(e) =>
																handleAccountingDeleteAction(e, index)
															}
														/>
													</i>
												</button>
											</div>
										)} */}
									</div>
								))
							) : (
								<div></div>
							)}
							<div className='portal-row'>
								<div className='portal-col'>

									<button
										className='add-account-btn'
										style={{ background: 'transparent' }}
										onClick={handleAddAccountingInfo}
										disabled={isDisabled}
									>
										<img
											src={plusIcon}
											alt='Add surcharge'
											title='Add surcharge'
											className='pr-1'
										/>
										<span className='add-account-btn'>{t('CAPTURE_AWB.ADD_ACCNT_INFO')}</span>
									</button>
								</div>
							</div>
						</div>
					</div>
					<div className='portal-row'>
						<div className='portal-col customs-info-wrapper'>
							<div className='portal-row'>
								<div className='portal-col'>
									<label className='section-sub-heading mb-0'>
										{t('CAPTURE_AWB.CUST_INFO')}
									</label>
								</div>
							</div>
							{customsInformationDetails && customsInformationDetails?.length ? (
								customsInformationDetails?.map((info, index) => (
									<div className='customs-info-section form-row'>
										<div className='shipping-deparr-row'>

											<div
												className={`form-group ${hasError('isoCountryCode', error) ? "red-border" : ""
													}`}
											>
												<CommonInput
													id={`isoCountryCode${index}`}
													type='text'
													disabled={isDisabled}
													label={t('CAPTURE_AWB.ISO_CNTRY_CODE')}
													maxLength='2'
													value={info.countryCode ? info.countryCode.toUpperCase() : ''}
													onChange={(e) => {
														const val = e.target.value
														customsInformationDetails[index].countryCode =
															val && val.trim() !== '' ? val.toUpperCase() : val
														setAwbDetails((prevState) => ({
															...prevState,
															customsInformationDetails:
																customsInformationDetails,
														}))
													}}
													onBlur={(e) => {
														validateAlphaIfPresent(
															e.target.value,
															setError,
															`isoCountryCode${index}`
														)
														validateFieldLengthIfPresent(
															e.target.value,
															setError,
															`isoCountryCode${index}`,
															null,
															null,
															2
														)
													}}
													aria-invalid={hasError(`isoCountryCode${index}`, error)}
													onFocus={(e) => {
														removeError(e, setError)
													}}
													error={error && error[`isoCountryCode${index}`]
														? t(error[`isoCountryCode${index}`], { ns: 'errors' })
														: ''}
												/>
											</div>


											<div
												className={`form-group ${hasError(`informationID${index}`, error) ? "red-border" : ""
													}`}
											>
												<CommonInput
													id={`informationID${index}`}
													type='text'
													disabled={isDisabled}
													label={t('CAPTURE_AWB.INFO_ID')}
													maxLength='3'
													placeholder=''
													value={info.informationId ? info.informationId.toUpperCase() : ''}
													onChange={(e) => {
														customsInformationDetails[index].informationId = e
															.target.value
															? e.target.value.split(' ').join('')
															: ''
														setAwbDetails((prevState) => ({
															...prevState,
															customsInformationDetails:
																customsInformationDetails,
														}))
													}}
													onBlur={(e) => {
														validateAlphaIfPresent(
															e.target.value,
															setError,
															`informationID${index}`
														)
														validateFieldLengthIfPresent(
															e.target.value,
															setError,
															`informationID${index}`,
															null,
															null,
															3
														)
													}}
													aria-invalid={hasError(`informationID${index}`, error)}
													onFocus={(e) => {
														removeError(e, setError)
													}}
													error={error && error[`informationID${index}`]
														? t(error[`informationID${index}`], { ns: 'errors' })
														: ''}
												/>
											</div>


										</div>

										<div className='shipping-deparr-row'>

											<div
												className={`form-group ${hasError(`customsInfoId${index}`, error) ? "red-border" : ""
													}`}
											>
												<CommonInput
													id={`customsInfoId${index}`}
													type='text'
													disabled={isDisabled}
													label={t('CAPTURE_AWB.CUST_INFO_ID')}
													maxLength='2'
													value={info.customsInformationId ? info.customsInformationId.toUpperCase() : ''}
													onChange={(e) => {
														customsInformationDetails[
															index
														].customsInformationId = e.target.value
																? e.target.value.split(' ').join('')
																: ''
														setAwbDetails((prevState) => ({
															...prevState,
															customsInformationDetails:
																customsInformationDetails,
														}))
													}}
													onBlur={(e) => {
														validateAlphaIfPresent(
															e.target.value,
															setError,
															`customsInfoId${index}`
														)
														validateFieldLengthIfPresent(
															e.target.value,
															setError,
															`customsInfoId${index}`,
															2,
															1,
															null
														)
													}}
													aria-invalid={hasError(`customsInfoId${index}`, error)}
													onFocus={(e) => {
														removeError(e, setError)
													}}
													error={error && error[`customsInfoId${index}`]
														? t(error[`customsInfoId${index}`], { ns: 'errors' })
														: ''}
												/>
											</div>

											<div
												className={`form-group ${hasError(`suppCustomsInfo${index}`, error) ? "red-border" : ""
													}`}
											>
												<CommonInput
													id={`suppCustomsInfo${index}`}
													type='text'
													disabled={isDisabled}
													label={t('CAPTURE_AWB.SUP_INFO_ID')}
													maxLength='35'
													value={info.supplementaryCustomsInformation ? info.supplementaryCustomsInformation.toUpperCase() : ''}
													onChange={(e) => {
														customsInformationDetails[
															index
														].supplementaryCustomsInformation = e.target.value
														setAwbDetails((prevState) => ({
															...prevState,
															customsInformationDetails:
																customsInformationDetails,
														}))
													}}
													onBlur={(e) => {
														validateSuppleCusInfoIfPresent(
															e.target.value,
															setError,
															`suppCustomsInfo${index}`
														)
													}}
													aria-invalid={hasError(
														`suppCustomsInfo${index}`,
														error
													)}
													onFocus={(e) => {
														removeError(e, setError)
													}}
													error={error && error[`suppCustomsInfo${index}`]
														? t(error[`suppCustomsInfo${index}`], {
															ns: 'errors',
														})
														: ''}
												/>
											</div>

										</div>
										{customsInformationDetails?.length > 1 && (

											<div className='delete-section ml-auto mt-auto' onClick={(e) => handleDeleteAction(e, index)}>
												<img src={deleteIcon} alt="Trash" title="Trash" id='Trash-icon' />
												<span>{t("CAPTURE_AWB.REMOVE")}</span>
											</div>
											// <div className='col-12 col-lg-1'>
											// 	<button className='delete-button'>
											// 		<i className='icon'>
											// 			<img
											// 				src={deleteIcon}
											// 				alt='Delete'
											// 				title='Delete'
											// 				onClick={(e) => handleDeleteAction(e, index)}
											// 			/>
											// 		</i>
											// 	</button>
											// </div>
										)}
									</div>
								))
							) : (
								<div></div>
							)}
							<div className='portal-row'>
								<div className='portal-col'>

									<button
										className='add-account-btn'
										style={{ background: 'transparent' }}
										onClick={handleAddCustomsInfo}
										disabled={isDisabled}
									>
										<img
											src={plusIcon}
											alt='Add surcharge'
											title='Add surcharge'
											className='pr-1'
										/>
										<span className='add-account-btn'>{t('CAPTURE_AWB.ADD_CUST_INFO')}</span>
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default CustomsDetails
